import React, { Component } from "react";
import { I18n } from 'aws-amplify';
import {
    Row,
    Col,
    Form,
    Icon,
    Spin,
    Input,
    Select,
    Button
} from 'antd';

import styled from 'styled-components';

const { Option } = Select;

const BoxSpin = styled.div`
  text-align: center;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
`

class ExceptionsProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {

            this.setState({
                formState: values,
                send: true
            })
            

            if (!err) {
                this.props.action(values);
            }
        });
    };

    componentDidUpdate(prevProps, prevState) {

        if (!prevProps) return;
        if (!prevState) return;

        if (this.props.errors != prevProps.errors && this.props.errors) {
            Object.keys(this.props.errors).map(field => {
                this.props.form.setFields({
                    [field]: {
                        value: this.state.formState[field],
                        errors: [new Error(this.props.errors[field].errorMessage)],
                    },
                });
            });
        }
    }

    render() {
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
        const { partners, products } = this.props

        if (!partners) {
            return (
                <BoxSpin>
                    <Spin />
                </BoxSpin>
            )
        }


        return (
            <Form onSubmit={this.handleSubmit}>
                <Row>
                <Col sm={7}>
                        <Form.Item
                            label={I18n.get("Marca/Produto")}>
                            {getFieldDecorator('productId', {
                                rules: [{ required: false, message: 'ops!' }],
                            })(
                                <Select
                                    className="SelectMin"
                                    style={{ width: "100%" }}
                                    showSearch={true}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }

                                >

                                    {
                                        products.map((item,index) => {
                                            return <Option value={item.code} disabled={!item.enabled} className="SelectMin">{item.label}</Option>
                                        })
                                    }

                                    

                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col sm={7}>
                        <Form.Item
                            label={I18n.get("Parceiro")}>
                            {getFieldDecorator('partnerId', {
                                rules: [{ required: false, message: 'ops!' }],
                            })(
                                <Select
                                    className="SelectMin"
                                    style={{ width: "100%" }}
                                    showSearch={true}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }

                                >

                                    {
                                        partners.map((item,index) => {
                                            return <Option value={item.code} disabled={item.enabled} className="SelectMin">{item.label}</Option>
                                        })
                                    }

                                    

                                </Select>
                            )}
                        </Form.Item>
                    </Col>
             


                    <Col sm={5}>
                        <Form.Item
                            label={I18n.get("Porcentagem")}>
                            {getFieldDecorator('commission', {
                                rules: [{ required: false, message: 'ops!' }],
                            })(
                                <Input 
                                    placeholder={I18n.get("% Padrão")}
                                />
                            )}
                        </Form.Item>
                    </Col>

                    <Col sm={2}>
                        <Form.Item className="labelClean" label="&nbsp;">
                            <Button
                                type="primary"
                                shape="round"
                                htmlType="submit"
                                disabled={!partners}
                                // loading={this.props.task.busy}
                            >
                                {I18n.get("Adicionar")}
                            </Button>
                        </Form.Item>
                    </Col>                    

                </Row>

            </Form>
        )
    }
}



const FormExceptionsProduct = Form.create({})(ExceptionsProduct);

export default FormExceptionsProduct;

